module.exports = __webpack_public_path__ + "img/头盔检测.91615fee.png";